import { useQuery } from '@tanstack/react-query'
import { mealPlanService } from './meal-plan.service'

export function useMealPlan(weekStartDate: string) {
  return useQuery({
    queryKey: ['meal-plan', weekStartDate],
    queryFn: () => mealPlanService.getWeeklyMealPlan(weekStartDate),
    enabled: !!weekStartDate,
  })
}
